import { Component, Input, OnInit } from '@angular/core'
import { Feature } from '../../../types'
import { FormsModule } from '@angular/forms'

@Component({
   selector: 'app-feature',
   standalone: true,
   imports: [FormsModule],
   templateUrl: './feature.component.html',


})
export class FeatureComponent {
   @Input() feature!: Feature

   constructor() { }

   determineStep(type: string) {
      if (type === 'double' || type === 'float') {
         return 0.1
      }
      else {
         return 1
      }
   }
}
